import script from "./FilterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterBar.vue?vue&type=script&setup=true&lang=js"

import "./FilterBar.vue?vue&type=style&index=0&id=3f5c20b5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5c20b5"]])

export default __exports__